import { createContext, useContext, useState } from 'react'
import { useDadosOrcamentoPedido } from '../hooks/useDadosOrcamentoPedido'

export const OrcamentoPedidoContext = createContext()

export function OrcamentoPedidoProvider({ children }) {
  const { isLoading, infoProposta, itens, refetch, isRefetching, isError, solicitarCaricatura, solicitarCaricaturaLoading } =
    useDadosOrcamentoPedido()
  const [recalculateProductPrice, setRecalculateProductPrice] = useState(true)

  function fnRecalculateProductPrice(status) {
    setRecalculateProductPrice(status)
  }

  const pedidoBloqueado = !!infoProposta?.valida_bloqueio || !!infoProposta?.perdido

  const [informacoesFrete, setInformacoesFrete] = useState({
    nome_transportadora: '',
    original_valor_frete: '',
    original_valor_imposto: '',
    original_valor_total_frete_30: '',
    prazo_entrega: '',
    valor_frete: '',
    valor_imposto: '',
    valor_total_frete_30: '',
    valor_total_frete_itens: '',
  })

  function handleInformacoesFrete(informacoes) {
    setInformacoesFrete(informacoes)
  }

  const itensPermitidos = itens?.filter((item) => item.exibicao_proposta === 'S')

  const loading = isLoading || isRefetching

  return (
    <OrcamentoPedidoContext.Provider
      value={{
        isLoading: loading,
        infoProposta,
        itens,
        handleInformacoesFrete,
        informacoesFrete,
        pedidoBloqueado,
        itensPermitidos,
        refetch,
        isRefetching,
        isError,
        fnRecalculateProductPrice,
        recalculateProductPrice,
        solicitarCaricatura,
        solicitarCaricaturaLoading,
      }}
    >
      {children}
    </OrcamentoPedidoContext.Provider>
  )
}

export function useOrcamentoPedido() {
  const context = useContext(OrcamentoPedidoContext)
  if (!context) {
    throw new Error('useOrcamentoPedido must be used within a OrcamentoPedidoProvider')
  }
  return context
}
